import React from "react";
import { FontProps } from "../types";
import { classNames } from "helpers/string";
import paragraphStyles from "./styles.module.css";

interface Props extends FontProps {
  styles: any;
}

export const Paragraph = ({ styles, children, className, ...props }: Props) => (
  <p
    className={`${classNames(paragraphStyles, props)} ${classNames(styles, {
      className
    })}`}
  >
    {children}
  </p>
);
